module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/27_b84eb7d404ce55d5c25a59ae24cea5c1.jpg";